import React from "react";
import { Col, Modal } from "antd";
import AccountInputValue from "../../commons/components/accountInputValue"
import PlusIcon from "../../commons/icons/plusIcon";
import MinusIcon from "../../commons/icons/minusIcon";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import Utils from "../../commons/utils/utils";

import { setSecondaryEmail } from "../../store/actions/userLoginActions";
import Message from '../../commons/utils/message'
import MailIcon from "../../commons/icons/mailIcon";
import Loading from "../../commons/components/loading";

import Http from "../../commons/utils/Http";

export default ({editing}) => {
    const [showValidateCode, setShowValidateCode] = useState(false);

    const [newEmail, setNewEmail] = useState("");
    const [receivedCode, setReceivedCode] = useState("");

    const { userData } = useSelector(state => state.userLogin);
    const listEmails = userData.secondary_emails ? userData.secondary_emails : [];

    const [loading, setLoading] = useState(false);

    const [hasErrorEmail, setHasErrorEmail] = useState(false);
    const [hasErrorCode, setHasErrorCode] = useState(false);
    const [errorMsgEmail, setErrorMsgEmail] = useState("");
    const [errorMsgCode, setErrorMsgCode] = useState("");

    const dispatch = useDispatch();

    useEffect( () => {
        if (!editing) {
            setHasErrorEmail(false);
            setErrorMsgEmail("");
            setNewEmail("");
        }
    }, [editing]);

    function refreshToken() {
        let token = localStorage.getItem("token");
        Http.get(`/token-xchange?application_id=${2}&token=${token}`)
            .then(response => {
                if (!response.data.response.error) {
                    const token = response.data.data.access_token
                    localStorage.setItem('token', token);
                }
            }).catch(err => {
                setHasErrorEmail(true);
                setErrorMsgEmail(err.response.data.response.message);
                setLoading(false);
            })
    }

    function updateSecondaryEmail(email) {
        const body = { "user_id": userData.id, "email": email }

        Http.put('/users/update-secondary-email', body, Http.headers)
            .then(response => {
                const responseData = response.data.response
                if (!responseData.error) {
                    setLoading(false);
                    listEmails.splice(listEmails.indexOf(email), 1);
                    dispatch(setSecondaryEmail(listEmails));

                    refreshToken();
                }
            }).catch(err => {
                setHasErrorEmail(true);
                setErrorMsgEmail(err.response.data.response.message);
                setLoading(false);
            })
    }

    function requestEmailChange() {
        const body = { "user_id": userData.id, "previous_email": null, "new_email": newEmail, "main_email": false }
        Http.put('/users/request-email-change', body, Http.headers)
            .then(response => {
                const responseData = response.data.response
                if (!responseData.error) {
                    setShowValidateCode(true);
                    setLoading(false);
                }
            }).catch(err => {
                setHasErrorEmail(true);
                setErrorMsgEmail(err.response.data.response.message);
                setLoading(false);
            })
    }

    function validEmail() {
        let valid = true;
        if (newEmail === "") {
            setHasErrorEmail(true);
            setErrorMsgEmail("Informe um e-mail");
            valid = false;
        } else if (!Utils.validateEmail(newEmail)) {
            setHasErrorEmail(true);
            setErrorMsgEmail("E-mail inválido");
            valid = false;
        }

        return valid;
    }

    const validCode = () => {
        function validateForm() {
            let valid = true;

            if (receivedCode === "") {
                setHasErrorCode(true);
                setErrorMsgCode("Informe um código");
                valid = false;
            }

            return valid;
        }

        function handlConfirmar() {
            if (validateForm()) {
                setLoading(true);

                const bodyCheckCode = { "user_id": userData.id, "code": receivedCode }
                Http.put('/users/change-email', bodyCheckCode, Http.headers)
                    .then(response => {
                        const responseData = response.data.response
                        if (!responseData.error) {
                            setShowValidateCode(false);
                            Message.showSuccess(responseData.message);
                            setLoading(false);
                            listEmails.push(newEmail)
                            dispatch(setSecondaryEmail(listEmails));
                            setNewEmail("");

                            refreshToken();
                        }
                    }).catch(err => {
                        setHasErrorCode(true);
                        setErrorMsgCode(err.response.data.response.message);
                        setLoading(false);
                    })
            }
        }

        function handleCancel() {
            setShowValidateCode(false);
            setHasErrorCode(false);
        }

        function renderForm() {
            if (loading) {
                return (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                        <Loading width={50} height={50} />
                    </div>
                )
            } else {
                return (
                    <>
                        <p className={"modal-content-describe"}>Um código de verificação foi enviado para o seu e-mail, insira-o no campo abaixo para concluir.</p>
                        <p><MailIcon style={{ marginRight: 8 }} /> <span>{newEmail}</span></p>
                        <AccountInputValue name={"received_code"} labelText={"Insira o código aqui"} value={receivedCode}
                            onChange={(e) => { setReceivedCode(e.target.value); setHasErrorCode(false) }}
                            hasError={hasErrorCode} error={errorMsgCode} />
                    </>
                );
            }
        }

        return (
            <Modal
                visible={showValidateCode}
                title="Etapa de segurança"
                centered={true}
                onCancel={handleCancel}
                onOk={handlConfirmar}
                footer={[
                    <a key="back" style={{ marginRight: 24 }} className={"account-link"}
                        onClick={handleCancel}>Cancelar
                    </a>,
                    <button key="submit" type="primary" className={"account-button account-button-primary"}
                        onClick={handlConfirmar}>Confirmar e prosseguir
                    </button>
                ]}
            >
                {renderForm()}
            </Modal>
        );
    }

    function handleAdicionar(e) {
        e.preventDefault();

        if (validEmail()) {
            requestEmailChange();
        }
    }

    if (editing) {
        return (
            <>
                <Col span={6} style={{ paddingLeft: 0 }}>
                    <ul> {listEmails.map((email, index) =>
                        <li key={index} style={{ marginLeft: -25, display: "flex", alignItems: "center" }} className={"account-list"}> {email}
                            <button type='button' style={{ marginLeft: 10 }} className={"account-button-minus"} onClick={() => updateSecondaryEmail(email)}>
                                <MinusIcon className={"account-button-icon"} />
                            </button>
                        </li>)}
                    </ul>
                    <div style={{ display: "flex", alignItems: "center"}}>
                        <Col span={20}>
                            <AccountInputValue name={"email"} labelText={"Novo E-mail de recuperação"} value={newEmail}
                                onChange={(e) => { setNewEmail(e.target.value); setHasErrorEmail(false) }}
                                hasError={hasErrorEmail} error={errorMsgEmail} />
                        </Col>

                        <Col span={14}>
                            <button style={{ marginLeft: 20 }} onClick={(e) => handleAdicionar(e)}
                                className={"account-button-plus-icon account-button-default-plus"}>
                                <PlusIcon className={"account-button-icon"} />Adicionar
                            </button>
                        </Col>
                        {validCode()}
                    </div>
                </Col>
            </>
        )
    } else {
        return (
            <Col span={6} style={{ paddingLeft: 0 }}>
                <ul style={{ paddingLeft: '10px' }}> 
                    {listEmails.map((email, index) => (
                        <li 
                            key={index} 
                            style={{  marginBottom: 12 }} 
                            className={"account-list"}
                        > 
                            {email}
                        </li>
                    ))}
                </ul>
            </Col>
        )
    }
}
